import { VIDEO_SETTINGS_SUPPORTED_TABS } from '../../constants/feature-support';

export const getThumbnailSupportedProfilesFromSelection = (selectedServices: string[]): string[] => {
  return selectedServices.reduce((serviceList, serviceName) => {
    const sanitised = serviceName.toLowerCase();

    if (VIDEO_SETTINGS_SUPPORTED_TABS.includes(sanitised)) {
      serviceList.push(sanitised);
    }

    return serviceList;
  }, [] as string[]);
};
